module.exports = __webpack_public_path__ + "static/media/tometoyou.7d0de6e5.jpg";